const makeRelativePixelToRem = (htmlPx: number) => {
  return (px: number) => {
    const parsedPx = px / htmlPx
    if (Number.isNaN(parsedPx)) throw Error('Failed Parse Pixel')

    return `${parsedPx}rem`
  }
}

const px2rem = makeRelativePixelToRem(16)

export { px2rem }

export function toHSL({ h, s, l }: HSLColor) {
  return `hsl(${h}, ${s}%, ${l}%)`
}
export function toHSLA({ h, s, l, a }: HSLColor & { a: number }) {
  return `hsla(${h}, ${s}%, ${l}%, ${a})`
}

export function darken({ h, s, l }: HSLColor, amount: number) {
  return toHSL({ h, s, l: l - amount })
}

export function lighten({ h, s, l }: HSLColor, amount: number) {
  return toHSL({ h, s, l: l + amount })
}

export function toGrayscale({ h, l }: HSLColor) {
  return toHSL({ h, s: 0, l })
}

export type HSLColor = { h: number; s: number; l: number }
